/**
 * Formatierung fuer die neuen Auswertungsseiten (39-10 ff.) -- ausschliesslich Anzeigerundung,
 * keine Rechenlogik. Alle Aggregate (Veraenderung, Anteil, Zellzustaende) liefert der Server
 * bereits fertig gerundet (39-08); hier wird nur noch fuer die deutsche Lokalisierung formatiert.
 *
 * '–' (U+2013) ist der projektweite Platzhalter fuer "kein Wert" (siehe `utils/formatting.ts`).
 */
const NO_VALUE = '–';

function toNumber(value: string | null): number | null {
  if (value === null) {
    return null;
  }
  const parsed = Number(value);
  return Number.isNaN(parsed) ? null : parsed;
}

/** Ganze Tonnen, rechtsbuendig gedacht -- Rundung erst hier, der Server liefert ungerundet. */
export function formatTonnes(value: string | null): string {
  const num = toNumber(value);
  if (num === null) {
    return NO_VALUE;
  }
  return new Intl.NumberFormat('de-DE', { maximumFractionDigits: 0 }).format(
    num
  );
}

/** Eine Nachkommastelle, ohne Prozentzeichen -- fuer Werte, die das Zeichen selbst anhaengen. */
export function formatPercent(value: string | null): string {
  const num = toNumber(value);
  if (num === null) {
    return NO_VALUE;
  }
  return new Intl.NumberFormat('de-DE', {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  }).format(num);
}

/** Wie `formatPercent`, mit angehaengtem Prozentzeichen (Anteile, Compliance-Marktanteil). */
export function formatShare(value: string | null): string {
  const formatted = formatPercent(value);
  return formatted === NO_VALUE ? NO_VALUE : `${formatted} %`;
}

/** Veraenderung mit erzwungenem Vorzeichen ausser bei exakt Null (Sketch: `fDelta`). */
export function formatChange(value: string | null): string {
  const num = toNumber(value);
  if (num === null) {
    return NO_VALUE;
  }
  return new Intl.NumberFormat('de-DE', {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
    signDisplay: 'exceptZero',
  }).format(num);
}
